import { render, staticRenderFns } from "./DogShopManage.vue?vue&type=template&id=40f59fe6&scoped=true"
import script from "./DogShopManage.vue?vue&type=script&lang=js"
export * from "./DogShopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f59fe6",
  null
  
)

export default component.exports